import { Competition, LangObject, Nullable, Profile } from "@brg/api";
import React from "react";
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty";

export type RequestFilterT = {
    competitionId: string;
    projectId: string;
    competitionStatus: number[];
    competitionIds: Nullable<string[]>;
    profile: Profile;
    lang: string;
    disableRequest?: boolean;
    cmptlnglst?: boolean;
}

export const EMPTY_HEAD_TEXT = createEmptyLangObject('', ['ru', 'en']) as LangObject[];

const parseHeadTextValue = (value?: LangObject[] | string | null): LangObject[] | null => {
    if (!value) return null;

    if (Array.isArray(value)) {
        return value as LangObject[];
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;

        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
                return parsed as LangObject[];
            }
            // legacy: plain string stored without JSON array wrapper
            if (typeof parsed === 'string' && parsed.trim()) {
                return createEmptyLangObject(parsed, ['ru', 'en']) as LangObject[];
            }
        } catch {
            // legacy: non-JSON plain string
            return createEmptyLangObject(trimmed, ['ru', 'en']) as LangObject[];
        }
    }

    return null;
};

export const hasHeadTextContent = (value?: LangObject[] | string | null): boolean => {
    const parsed = parseHeadTextValue(value);
    if (!parsed) return false;
    return parsed.some((item) => !!String(item?.name ?? '').trim());
};

export const normalizeHeadText = (value?: LangObject[] | string | null): LangObject[] => {
    const parsed = parseHeadTextValue(value);
    if (parsed?.length) {
        return parsed;
    }
    return EMPTY_HEAD_TEXT;
};

export const serializeHeadText = (value: LangObject[]): string => JSON.stringify(value);

interface IProps {
    requestFilter?: RequestFilterT;
    currentList: Record<string, any>[];
    criteriaList: Record<string, any>[];
    nextCriteriaList: Record<string, any>[];
    prevCriteriaList: Record<string, any>[];
    prevCriteriaId: string; 
    nextCriteriaId?: string;
    voteEnd: string;
    currentCompId: string;
    disableNext: boolean;
    projectId: string;
    voiseSet: boolean;
    isLoading: boolean;
    isNextLoading: boolean;
    errorMessage?: string;
    competitions: Competition<'Local'>[];
    hasData?: boolean;
    headText: LangObject[];
    onToggleStatus: (flag: boolean) => void;
    resetData: () => void;
    updateData: () => void;
    setFilter: (data: RequestFilterT) => void;
    setVote: (data: any) => void;
    setHeadText: (text: LangObject[]) => void;
}

export const initialContext: IProps = {
    requestFilter: undefined,
    currentList: [],
    criteriaList: [],
    nextCriteriaList: [],
    prevCriteriaList: [],
    prevCriteriaId: '',
    nextCriteriaId: undefined,
    voiseSet: false,
    isLoading: false,
    isNextLoading: false,
    disableNext: false,
    hasData: false,
    voteEnd: 'inProgress',
    errorMessage: '',
    currentCompId: '',
    competitions: [],
    projectId: '',
    headText: EMPTY_HEAD_TEXT,
    resetData: () => {},
    updateData: () => {},
    onToggleStatus: (flag: boolean) => {},
    setFilter: (data: RequestFilterT) => {},
    setVote: (data: any) => {},
    setHeadText: () => {},
};

const VoteContext = React.createContext(initialContext);

export default VoteContext;
import { Competition, LangObject, Nullable, Profile } from "@brg/api";
import React from "react";
import { createEmptyLangObject } from "shared/components/__ADDONS__/__SAFEAPI__/Empty";

export type RequestFilterT = {
    competitionId: string;
    projectId: string;
    competitionStatus: number[];
    competitionIds: Nullable<string[]>;
    profile: Profile;
    lang: string;
    disableRequest?: boolean;
    cmptlnglst?: boolean;
}

export const EMPTY_HEAD_TEXT = createEmptyLangObject('', ['ru', 'en']) as LangObject[];

const parseHeadTextValue = (value?: LangObject[] | string | null): LangObject[] | null => {
    if (!value) return null;

    if (Array.isArray(value)) {
        return value as LangObject[];
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return null;

        try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) {
                return parsed as LangObject[];
            }
            // legacy: plain string stored without JSON array wrapper
            if (typeof parsed === 'string' && parsed.trim()) {
                return createEmptyLangObject(parsed, ['ru', 'en']) as LangObject[];
            }
        } catch {
            // legacy: non-JSON plain string
            return createEmptyLangObject(trimmed, ['ru', 'en']) as LangObject[];
        }
    }

    return null;
};

export const hasHeadTextContent = (value?: LangObject[] | string | null): boolean => {
    const parsed = parseHeadTextValue(value);
    if (!parsed) return false;
    return parsed.some((item) => !!String(item?.name ?? '').trim());
};

export const normalizeHeadText = (value?: LangObject[] | string | null): LangObject[] => {
    const parsed = parseHeadTextValue(value);
    if (parsed?.length) {
        return parsed;
    }
    return EMPTY_HEAD_TEXT;
};

export const serializeHeadText = (value: LangObject[]): string => JSON.stringify(value);

interface IProps {
    requestFilter?: RequestFilterT;
    currentList: Record<string, any>[];
    criteriaList: Record<string, any>[];
    nextCriteriaList: Record<string, any>[];
    prevCriteriaList: Record<string, any>[];
    prevCriteriaId: string; 
    nextCriteriaId?: string;
    voteEnd: string;
    currentCompId: string;
    disableNext: boolean;
    projectId: string;
    voiseSet: boolean;
    isLoading: boolean;
    isNextLoading: boolean;
    errorMessage?: string;
    competitions: Competition<'Local'>[];
    hasData?: boolean;
    headText: LangObject[];
    onToggleStatus: (flag: boolean) => void;
    resetData: () => void;
    updateData: () => void;
    setFilter: (data: RequestFilterT) => void;
    setVote: (data: any) => void;
    setHeadText: (text: LangObject[]) => void;
}

export const initialContext: IProps = {
    requestFilter: undefined,
    currentList: [],
    criteriaList: [],
    nextCriteriaList: [],
    prevCriteriaList: [],
    prevCriteriaId: '',
    nextCriteriaId: undefined,
    voiseSet: false,
    isLoading: false,
    isNextLoading: false,
    disableNext: false,
    hasData: false,
    voteEnd: 'inProgress',
    errorMessage: '',
    currentCompId: '',
    competitions: [],
    projectId: '',
    headText: EMPTY_HEAD_TEXT,
    resetData: () => {},
    updateData: () => {},
    onToggleStatus: (flag: boolean) => {},
    setFilter: (data: RequestFilterT) => {},
    setVote: (data: any) => {},
    setHeadText: () => {},
};

const VoteContext = React.createContext(initialContext);

export default VoteContext;
